module.exports = new __parcel__URL__("c1s7.056a8793.png").toString();